//Can you give some college comparisons for basketball player nikolas khamenia
export const demoCollegeComps = {
  "94cameron_boozer": [
    {
      name: "Paolo Banchero",
      image:
        "https://d3cin4duo2vkym.cloudfront.net/images/2022/1/24/Paolo_Banchero.jpg",
      position: "F",
      ball_handling: 75,
      scoring: 100,
      rebounding: 85,
      defense: 80,
      playmaking: 85,
      school: "Duke",
      content:
        "Cameron Boozer, a 6'9 power forward, is often compared to Paolo Banchero, a former Duke player who was the first pick in the 2022 NBA Draft. Cameron has the offensive polish of Paolo Banchero",
    },
    {
      name: "Kevin Love",
      image:
        "https://images.seattletimes.com/wp-content/uploads/2008/02/2004174315.jpg?d=300x0",
      position: "C",
      ball_handling: 85,
      scoring: 80,
      rebounding: 90,
      defense: 70,
      playmaking: 90,
      school: "UCLA",
      content:
        "Boozer's outlet passing ability has been likened to that of Kevin Love, showcasing his exceptional court vision and passing skills for a big man",
    },
    {
      name: "Carlos Boozer",
      image:
        "https://cdn.vox-cdn.com/thumbor/Bn13O_YpAn-cHskevpvcOrI_lZ4=/1400x1400/filters:format(jpeg)/cdn.vox-cdn.com/uploads/chorus_asset/file/9895219/72478111.jpg.jpg",
      position: "C",
      ball_handling: 55,
      scoring: 80,
      rebounding: 100,
      defense: 80,
      playmaking: 65,
      school: "Duke",
      content:
        "Physical stature: Cameron has a similar body type to his father, former NBA All-Star Carlos Boozer",
    },
  ],
  "22nikolas_khamenia": [
    {
      name: "Kyle Singler",
      image:
        "https://nypost.com/wp-content/uploads/sites/2/2024/11/12-duke-blue-devils-walks-42368190.jpg?w=1024",
      position: "F",
      ball_handling: 95,
      scoring: 80,
      rebounding: 95,
      defense: 90,
      playmaking: 95,
      school: "Duke",
      content:
        "Kyle Singler: A versatile forward with a high basketball IQ and the ability to impact the game in multiple ways.",
    },
    {
      name: "Mikal Bridges",
      image:
        "https://lh4.googleusercontent.com/proxy/tjpHJWQ_zmklASIqN5E6lQCXpLVZxHEg-2wSlTOQAyLYB5SkbBhu4Kaz0ZfKWyhaYRN3TmlWiASn19n6aFiKzIgu4s-A_zD6FSi5pYowc8ihrw6D7EHFix4PPdF0KNt4YaNT1A1LpxZ4p-PnHa1B6Eorw-1ettIjQhCk3QWyiA3VWkMf8Y4COJM",
      position: "F",
      ball_handling: 85,
      scoring: 90,
      rebounding: 80,
      defense: 90,
      playmaking: 90,
      school: "Villanova",
      content:
        "Mikal Bridges: Known for his two-way play, shooting ability, and defensive prowess as a wing.",
    },
    {
      name: "Jabari Parker",
      image:
        "https://static01.nyt.com/images/2014/04/18/sports/18parker-1/18parker-1-superJumbo.jpg",
      position: "F",
      ball_handling: 75,
      scoring: 90,
      rebounding: 90,
      defense: 80,
      playmaking: 85,
      school: "Duke",
      content:
        "Jabari Parker: A skilled forward with the ability to score from multiple positions on the court.",
    },
  ],

  "36chris_cenac": [
    {
      name: "Chet Holmgren",
      image:
        "https://www.si.com/.image/c_fill,w_1200,ar_1:1,f_auto,q_auto,g_auto/MTg3OTQ0NTk2NzcxMTg2NjA2/ap22044189279811.jpg",
      position: "F",
      ball_handling: 75,
      scoring: 100,
      rebounding: 85,
      defense: 80,
      playmaking: 85,
      school: "Gonzaga",
      content:
        "A skilled big man with shot-blocking ability and perimeter skills.",
    },
    {
      name: "Evan Mobley",
      image:
        "https://assets-cms.thescore.com/uploads/image/file/446161/w768xh576_GettyImages-1231228398.jpg?ts=1616087960",
      position: "C",
      ball_handling: 85,
      scoring: 80,
      rebounding: 90,
      defense: 70,
      playmaking: 90,
      school: "USC",
      content: "A versatile defender who could play inside and out offensively",
    },
    {
      name: "Jalen Duren",
      image:
        "https://www.commercialappeal.com/gcdn/presto/2021/12/31/PMCA/720578ed-2355-4cb6-a5cf-0ee32d3423a8-USATSI_17359234.jpg",
      position: "C",
      ball_handling: 55,
      scoring: 80,
      rebounding: 100,
      defense: 80,
      playmaking: 65,
      school: "Memphis",
      content:
        "An athletic center with rim-running and shot-blocking capabilities.",
    },
  ],
  "2caleb_wilson": [
    {
      name: "Chris Bosh",
      image:
        "https://c8.alamy.com/comp/2NGG6EM/georgia-techs-chris-bosh-4-dunks-over-wake-forests-chris-ellis-in-the-second-half-of-wake-forests-73-66-win-at-lawrence-joel-coliseum-in-winston-salem-nc-sunday-jan-19-2003-bosh-lead-georgia-tech-with-22-pointsap-photochuck-burton-2NGG6EM.jpg",
      position: "C",
      ball_handling: 75,
      scoring: 100,
      rebounding: 85,
      defense: 80,
      playmaking: 85,
      school: "Georgia Tech",
      content:
        "Wilson's game has been likened to that of Chris Bosh during his college years5. This comparison stems from Wilson's combination of size (6'9), athleticism, and developing outside shot. Like Bosh, Wilson shows promise as a floor-spacer at the next level, with the ability to hit mid-range jumpers and step-back shots",
    },
    {
      name: "RJ Davis",
      image: "https://upload.wikimedia.org/wikipedia/commons/b/bd/RJ_Davis.jpg",
      position: "G",
      ball_handling: 85,
      scoring: 80,
      rebounding: 90,
      defense: 70,
      playmaking: 90,
      school: "North Carolina",
      content:
        "While Davis is a guard and Wilson is a forward, both are known for their scoring ability and impact on both ends of the court. Davis's all-around game and leadership could be a model for Wilson's potential impact",
    },
    {
      name: "Liam McNeeley",
      image:
        "https://s.hdnux.com/photos/01/45/64/71/26693240/3/ratio3x2_1920.jpg",
      position: "F",
      ball_handling: 55,
      scoring: 80,
      rebounding: 100,
      defense: 80,
      playmaking: 65,
      school: "Uconn",
      content:
        "McNeeley, like Wilson, is a highly-rated forward in the class of 2024. Both players are known for their shooting ability, with McNeeley being compared to Gradey Dick for his potential impact as a freshman",
    },
  ],
  "78kanon_cathcings": [
    {
      name: "Amari Bailey",
      image:
        "https://images.sidearmdev.com/resize?url=https%3A%2F%2Fdxbhsrqyrr690.cloudfront.net%2Fsidearm.nextgen.sites%2Fuclabruins.com%2Fimages%2F2023%2F2%2F13%2FAmari_Bailey_0953.jpg&height=300&type=webp",
      position: "F",
      ball_handling: 75,
      scoring: 100,
      rebounding: 85,
      defense: 80,
      playmaking: 85,
      school: "UCLA",
      content:
        "Both are athletic wings with the ability to play above the rim and impact the game on both ends of the floor.",
    },
    {
      name: "Brandon Miller",
      image:
        "https://www.al.com/resizer/v2/XIOBTPMZ5RD55AOF4DT3ZXV2RE.jpg?auth=df5f9c6a29093d885660a0ddd28abeb1c6fa375f1cc4f77a1ca854e9eb7e7ee4&width=500&quality=90",
      position: "F",
      ball_handling: 85,
      scoring: 80,
      rebounding: 90,
      defense: 70,
      playmaking: 90,
      school: "Alabama",
      content:
        "While Miller was more polished coming into college, both share similar size and potential as versatile forwards with outside shooting ability.",
    },
    {
      name: "Keyonte George",
      image:
        "https://cloudfront-us-east-1.images.arcpublishing.com/gray/O5GPCC7UYVBR7ENTUFFMEQ5Z2Y.jpg",
      position: "C",
      ball_handling: 55,
      scoring: 80,
      rebounding: 100,
      defense: 80,
      playmaking: 65,
      school: "Baylor",
      content:
        "Though George played guard, both he and Catchings entered college as highly-touted freshmen with scoring ability and NBA potential.",
    },
  ],
};
